import ApiService from "../../helpers/ApiHelper";

class InitiatedBookingService {
  static getInitiatedBookings(payload) {
    const query = payload.q ? `?q=${encodeURIComponent(payload.q)}` : '';
    return ApiService.request(
      `/api/v1/booking-steps/${payload.currentPage}/${payload.currentDate}${query}`,
      'get',
      {}
    )
  }

}
export default InitiatedBookingService
